import { scribeTokens as ui } from '../../components/scribe/tokens';
// Shared by the OCR editor and the report source preview.
export const ocrTextPanelSx = {
  flex: 1, minWidth: 0, minHeight: 0, display: 'flex', flexDirection: 'column',
  gap: 1.5, bgcolor: ui.colors.surface, border: 0, borderRadius: 0, p: 1.5, overflow: 'hidden',
};
export const ocrTextSurfaceSx = {
  flex: 1, minHeight: 0, width: '100%', boxSizing: 'border-box', p: 2,
  overflowY: 'auto', resize: 'none', fontFamily: ui.fontFamily, ...ui.typography.content,
  color: ui.colors.text, border: `1px solid ${ui.colors.border}`, borderRadius: `${ui.radius.control}px`, bgcolor: ui.colors.surface,
  '&:focus': { outline: `2px solid ${ui.colors.brand}`, outlineOffset: '-2px' },
  '&:disabled': { bgcolor: ui.colors.subtle },
};
